import { isChatCreatedSavedSearch } from 'components/widgets/ProjectInsights/Toolbar/getSavedSearchEditorType';
import { useSelectedGroupConfig } from 'components/widgets/ProjectInsights/Toolbar/useSelectedGroupConfig';
import { useGroupData } from 'hooks/useGroupData';
import { useSavedSearchQueryHash } from 'state/scoutChat';

/**
 * For the currently selected saved search, when it was created via a Scout
 * chat prompt, returns its raw ES query bodies instead of the locally-held
 * filter atoms - those never get populated for a scoutbot search, since
 * editing only happens through chat. Refetches whenever a chat turn reports
 * a filter change for this search via its query_md5.
 */
export const useScoutbotSavedSearchQueries = () => {
  const selectedGroup = useSelectedGroupConfig();
  const isScoutSearch = isChatCreatedSavedSearch(selectedGroup);
  const [savedSearchQueryHash] = useSavedSearchQueryHash();
  const queryHash = selectedGroup?.adk_query_id
    ? savedSearchQueryHash[selectedGroup.adk_query_id]
    : undefined;

  const group = useGroupData(
    isScoutSearch ? String(selectedGroup?.id) : undefined,
    queryHash,
  );

  return {
    isScoutSearch,
    rawQueries: isScoutSearch ? (group?.scoutbot?.queries ?? null) : null,
  };
};
